import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { FireEffect } from '../fire-effect/FireEffect';
import Countdown, { zeroPad } from 'react-countdown';

type PropTypes = {
  demonGamePlayedToday?: boolean;
  disabled?: boolean;
  handleDemonButtonClick: () => void;
  hideFire?: boolean;
  label: string;
  nextDemonSchedule?: number;
};

export const DemonButton = ({
  demonGamePlayedToday,
  disabled,
  handleDemonButtonClick,
  hideFire,
  label,
  nextDemonSchedule,
}: PropTypes) => {
  const theme = useTheme();
  const [enableButton, setEnableButton] = useState(false);

  const countdownRenderer = ({ hours, minutes, seconds }: any) => {
    return (
      <span>
        {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    );
  };

  return (
    <>
      {demonGamePlayedToday || enableButton ? (
        <Button
          variant="text"
          fullWidth
          sx={{
            color: '#88845f',
            border: '.5px solid',
            borderColor: theme.palette.demon.main,
            boxShadow: `0px 1px 1px 0px ${theme.palette.demon.main}, 1px 1px 3px 0px ${theme.palette.demon.main}, 1px 1px 4px 0px ${theme.palette.demon.main}, 3px 4px 7px 0px ${theme.palette.demon.main}`,
            backgroundColor: 'black',
          }}
          onClick={handleDemonButtonClick}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="h6">Demons return</Typography>
            <Typography variant="h6">
              <Countdown
                date={nextDemonSchedule}
                renderer={countdownRenderer}
                onComplete={() => setEnableButton(true)}
              />
            </Typography>
          </Stack>
        </Button>
      ) : (
        <Box>
          <Button
            variant="outlined"
            fullWidth
            disabled={disabled}
            onClick={handleDemonButtonClick}
            sx={{
              backgroundColor: 'transparent',
              border: '1px solid',
              fontSize: '18px',
              fontFamily: 'requiem',
              letterSpacing: 5,
              zIndex: 2,
              borderColor: theme.palette.demon.main,
              boxShadow: `0px 1px 1px 0px #cd0d01, 1px 1px 3px 0px #cd0d01, 1px 1px 4px 0px #cd0d01, 3px 4px 7px 0px #cd0d01b8`,
              color: theme.palette.demon.contrastText,
              ':hover': {
                borderColor: theme.palette.demon.light,
                color: theme.palette.demon.contrastText,
                textShadow: `
                0px 0px 4px #ff372a},
                0px 0px 20px #ff372a},
                0px 0px 20px #ff372a}a1,
                0px 0px 20px`,
              },
            }}
          >
            {label}
          </Button>
          {!hideFire ? <FireEffect /> : null}
        </Box>
      )}
    </>
  );
};
